<template>
  <div class="draft__card">
    <div class="rounded border p-6 bg-white info-panel">
      <div class="first-info">
        <div class="first-info__header">
          <div>
            <div class="text-gray-700 fw-bold mb-1 line-clamp fs-6"
                 :title="draft.insurer_title"
                 data-bs-toggle="tooltip"
                 data-bs-placement="bottom"
            >{{draft.insurer_title}}</div>
            <div class="text-gray-500">
              <span class="badge badge-secondary mr-1">{{draft.insurer_document}}</span>
              <span class="badge badge-light mr-1">{{ draft.insurer_person ? 'Физ. лицо' : 'Юр. лицо' }}</span>
              <span class="badge badge-light mr-1">{{ draft.insurer_resident ? 'Резидент' : 'Нерезидент' }}</span>
              <span @click="deleteDraft(draft.id)" class="badge badge-light-danger float-end cursor-pointer fw-normal">Удалить</span>
            </div>
          </div>
        </div>
        <hr class="text-gray-400">
        <div class="text-gray-500 fs-7">Номер: <span class="float-end text-gray-700">{{draft.id}}</span></div>
        <div class="text-gray-500 fs-7">Продукт: <span :title="draft.product" class="float-end text-info-emphasis fw-bold">{{ draft.product_name }}</span></div>
        <div class="text-gray-500 fs-7">Создан: <span class="float-end text-gray-600">{{draft.created}}</span></div>
        <div v-if="draft.user" class="text-gray-500 fs-7">Автор: <span class="float-end text-gray-600">{{draft.user}}</span></div>
      </div>
      <router-link
          v-if="getPageName(draft.product_type)"
          :to="{ name: getPageName(draft.product_type), query: { draft: draft.id } }"
          class="btn btn-xs btn-light btn-active-color-primary btn-block w-100 mt-3"
      >
        Оформить
      </router-link>
      <button
          v-else
          type="button"
          disabled
          class="btn btn-xs btn-light btn-block w-100 mt-3"
          title="Нет доступа к BPM ОГПО"
      >
        Оформить
      </button>
    </div>
  </div>
</template>

<script>
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export default {
  name: 'DraftCard',
  props: {
    draft: {
      type: Object,
      default: null
    },
    draftKey: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    deleteDraft(id) {
      this.$emit('deleteDraft', [id, this.draftKey])
    },
    getPageName(product) {
      const data = {
        1: 'Ogpo',
        2: 'Ogpo',
        3: 'Ogpo',
        4: 'Properties',
        5: 'Properties',
        6: 'Casco',
        7: 'BpmOgpo',
      }
      const page = data[product]
      if (product === 7 && !BpmOsgpoModule.Validator.isUserAllowed(this.$user)) {
        return null
      }
      return page
    }
  }
}
</script>

<style scoped>
  .mr-1 {
    margin-right: 3px;
  }
</style>